<div class="mt-3">
  <kl-add-products  [product]="dialogData?.data?.product" [isStock]="dialogData?.data?.isStock" (closeDialog)="cancel()" (dealWithAdded)="onDealAdded($event)"></kl-add-products>
</div>

